import { MessageOutlined } from "@ant-design/icons";
import { Alert, Badge, Dropdown, Flex, List } from "antd";
import { useNotificaciones } from "../../hooks";
import { LinkBtn } from "../../components/ui";
import React from "react";

const NotificationTrigger = React.forwardRef(
  ({ notifications, ...props }, ref) => (
    <span ref={ref} {...props}>
      <Badge count={notifications.length} overflowCount={99}>
        <MessageOutlined style={{ fontSize: "20px" }} />
      </Badge>
    </span>
  ),
);

export const NotificationCenter = () => {
  const { notifications } = useNotificaciones();
  const onClickMarcarLeido = (msg) => {
    console.log(msg, "--> Leido");
  };
  const items = [
    {
      key: "messages",
      label: (
        <div style={{ width: "250px" }}>
          <List
            size="small"
            itemLayout="horizontal"
            dataSource={notifications}
            renderItem={(msg, index) => (
              <List.Item
                key={index}
                style={{ padding: "4px" }}
                onClick={() => onClickMarcarLeido(msg)}
              >
                <Alert
                  message={
                    <>
                      {msg.mensaje}
                      <br />
                      <small>
                        <b>{msg.fechaenvio}</b>
                      </small>
                    </>
                  }
                  type={msg?.tipo}
                  showIcon
                  banner
                  style={{ width: "100%" }}
                />
              </List.Item>
            )}
            footer={
              <Flex justify="center" align="center">
                <LinkBtn disabled={notifications.length < 1} />
              </Flex>
            }
          />
        </div>
      ),
    },
  ];

  return (
    <Dropdown menu={{ items }} trigger={["click"]}>
      <NotificationTrigger notifications={notifications} />
    </Dropdown>
  );
};
